import { BaseRequest } from "../../BaseRequest";

export class ListCandidateVacancyRequest extends BaseRequest {
  public id?: number;
  public candidate?: string;
  public client?: string;
  public jobField?: string;
  public position?: string;
  public grade?: string;
  public folder?: string;
  public orderBy?: string;

  constructor(
    server: string,
    sessionId: string,
    id?: number,
    candidate?: string,
    client?: string,
    jobField?: string,
    position?: string,
    grade?: string,
    folder?: string,
    orderBy?: string
  ) {
    super(server, sessionId);
    this.id = id;
    this.candidate = candidate;
    this.client = client;
    this.jobField = jobField;
    this.position = position;
    this.grade = grade;
    this.folder = folder;
    this.orderBy = orderBy;
  }

  public override toXml(): string {
    var parameters: string = super.toXml();
    parameters += this.makeNode(this.id, 'id');
    parameters += this.makeNode(this.candidate, 'candidate');
    parameters += this.makeNode(this.client, 'client');
    parameters += this.makeNode(this.jobField, 'jobField');
    parameters += this.makeNode(this.position, 'position');
    parameters += this.makeNode(this.grade, 'grade');
    parameters += this.makeNode(this.folder, 'folder');
    parameters += this.makeNode(this.orderBy, 'orderBy');
    return super.wrapperXml("ListCandidateVacancy", parameters);
  }
}
